import { ConfigProvider, Popover } from "antd";
import classes from "./Commonhover.module.css";

function Commonpopover({
  content,
  children,
  styles,
  title,
  open,
}: {
  content: any;
  children: any;
  styles?: any;
  title: string;
  open: boolean;
}) {
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Popover: {
              titleMinWidth: 300,
            },
          },
        }}
      >
        <div style={styles}>
          <Popover
            // open={true}
            content={content}
            title={title}
            className={classes.commonhover}
            trigger={open ? "hover" : []}
          >
            {children}
          </Popover>
        </div>
      </ConfigProvider>
    </>
  );
}

export default Commonpopover;
